export const getFpId = (): number | null => {
  const fpId = sessionStorage.getItem('fpId')
  return fpId ? Number(fpId) : null
}

export const getSourceFpId = (): number | null => {
  const sourceFpId = sessionStorage.getItem('sourceFpId')
  return sourceFpId ? Number(sourceFpId) : null
}

export const isForceDisableLogo = (): boolean => {
  const forceDisableLogo = sessionStorage.getItem('forceDisableLogo')
  return forceDisableLogo === 'true'
}

/**
 * `displayLogo` 是 feature toggle v2 系統控制的 toggle，但因為 Loading 畫面比 zustand store
 * 初始化得早，才沿用跟 `forceDisableLogo` 相同的「URL 參數 → sessionStorage」介面傳給前端，而不是
 * 走 `useFeatureToggleV2`。優先權：`forceDisableLogo` 蓋過 `displayLogo`；兩者皆無時預設不顯示
 * （V2 專屬的新預設值，與舊有「預設顯示」相反）。詳見
 * docs/feature-toggle-v2-status/issues/display-logo-spec.md。
 */
export const shouldDisplayLogoV2 = (): boolean => {
  if (isForceDisableLogo()) return false
  return sessionStorage.getItem('displayLogo') === 'true'
}
